import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { JobCard } from "./JobsList";

export default function BlogSidebar() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios
      .get(constvar.api_url + "get_blog_list/6", { signal: controller.signal })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setBlogs(res.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load blogs:", error);
        }
      });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return (
    <div className="sf-sidebar-widget">
      <div className="sf-widget-header">
        <h3>Latest Blog</h3>
        <Link to="/blog">View All</Link>
      </div>
      <div className="sf-widget-body">
        {blogs.length > 0 ? (
          blogs.map((blog) => (
            <Link
              key={blog.id}
              to={"/blog/" + blog.id}
              className="sf-blog-item"
              style={{ textDecoration: "none" }}
            >
              <div className="sf-blog-thumb">
                <img src={blog.image} alt={blog.title} />
              </div>
              <div className="sf-blog-info">
                <div className="sf-blog-title">{blog.title}</div>
                <div className="sf-blog-date">{blog.created_at}</div>
              </div>
            </Link>
          ))
        ) : (
          <p style={{ fontSize: 12, color: "#94a3b8", margin: 0 }}>No blogs yet.</p>
        )}
      </div>
    </div>
  );
}